export default __webpack_public_path__ + "static/media/Lasse_SoMe1_Uden_outro.6c091a5a.mp4";